export default __webpack_public_path__ + "static/media/Doordash.23a14b34.svg";